// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2PDiC","list":"styles_list__3OCGV"};